module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-wrapper"
  }, [(_vm.information) ? _c('div', {
    staticClass: "document"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок информации"
    },
    model: {
      value: (_vm.information.title),
      callback: function($$v) {
        _vm.$set(_vm.information, "title", $$v)
      },
      expression: "information.title"
    }
  }), _vm._v(" "), _c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "placeholder": "Текст информации"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Дата и время публикации"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetime",
      "placeholder": "Дата"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "button is-fullwidth",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-fullwidth",
    attrs: {
      "to": {
        name: 'BrokerInformation'
      }
    }
  }, [_vm._v("ОТМЕНА")]), _vm._v(" "), (_vm.$route.params.id) ? _c('span', {
    staticClass: "button is-fullwidth is-danger",
    on: {
      "click": function($event) {
        return _vm.deleteBrokerInformation(_vm.information.id)
      }
    }
  }, [_vm._v("УДАЛИТЬ")]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1c8b31"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/BrokerInformationItem.vue
// module id = 961
// module chunks = 0